import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import { useToast } from 'hooks/useToast';
import { AccountAvatar } from '../../User/AccountAvatar';

type AccountDropdownItemProps = {
  href?: string;
  title: string;
  onSelect?: () => void;
};

export const AccountDropdownItem: React.FC<AccountDropdownItemProps> = ({
  href,
  title,
  onSelect,
}) => {
  if (href) {
    return (
      <DropdownMenuItem asChild>
        <Link to={href} className="w-full">
          {title}
        </Link>
      </DropdownMenuItem>
    );
  }

  return (
    <DropdownMenuItem
      onSelect={() => {
        onSelect?.();
      }}
    >
      {title}
    </DropdownMenuItem>
  );
};

export const AccountDropdown: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { addToast } = useToast();

  const handleSignOut = async () => {
    try {
      logout?.();
      addToast({
        title: 'Until next time!👋',
        description: 'You are successfully signed out.',
        type: 'success',
      });
      navigate('/');
    } catch (err) {
      addToast({
        title: 'Something went wrong!',
        description: 'Please try again later.',
        type: 'error',
      });
    }
  };

  return (
    <div className="flex items-center ml-4 md:ml-6">
      <div className="relative ml-3">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <AccountAvatar />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-48">
            <AccountDropdownItem href="/dashboard" title="Tableau de bord" />
            <AccountDropdownItem href="/account" title="Mon compte" />
            <AccountDropdownItem title="Déconnexion" onSelect={handleSignOut} />
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};
